import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';
import { IProjectAsset, ICreateProjectAssetPostData } from '../types';

interface ICreateProjectAssetParams {
    postData: ICreateProjectAssetPostData[];
    projectUuid: string
}

const createProjectAsset = async ({ postData, projectUuid }: ICreateProjectAssetParams): Promise<IProjectAsset> => {
    try {
        const response = await axiosInstance.post(`${API_ENDPOINTS.PROJECT_ASSETS(projectUuid)}`, postData);
        return response.data;
    } catch (error: any) {
        if (error.response?.status !== 500) {
            throw new Error(error.response.data);
        }
        throw new Error('An unexpected error occurred. Please try again.');
    }
};

export const useCreateProjectAsset = () => useMutation({
    mutationFn: createProjectAsset,
});

export default useCreateProjectAsset;
